import * as React from "react";

function SvgTransito(props) {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 920.418 560.803"
      {...props}
    >
      <path
        fill="#f2f2f2"
        d="M84.209 392.402h163v6h-163zM453.209 392.402h163v6h-163zM704.209 392.402h163v6h-163zM868.165 301.519a19.8 19.8 0 00-4.148 2.867 19.742 19.742 0 00-4.216-2.867 19.8 19.8 0 00-4.148 2.867 19.742 19.742 0 00-4.217-2.867s-6.501 3.197-6.483 7.105q0 .146.013.291c.222 2.558 6.944 3.21 10.637 2.005a15.247 15.247 0 008.364 0c3.677 1.225 10.535.523 10.736-2.065q.011-.145.01-.292c-.018-3.907-6.548-7.044-6.548-7.044z"
      />
      <path
        fill="#3f3d56"
        d="M6.972 167.108l-5.768-4.614 32.297-28.836h81.896v25.376l-53.059 35.757-55.366-27.683z"
      />
      <path
        fill="#ccc"
        d="M130.329 149.833v-15.599h-10.873v3.82l-4.059-4.396-26.529 28.836-10.381 6.921L62.39 287.016l24.275 24.275h56.416V163.648l-12.752-13.815z"
      />
      <path fill="#f2f2f2" d="M1.204 162.494h87.663v148.797H1.204z" />
      <path fill="#ccc" d="M35.232 274.957h16.149v36.334H35.232z" />
      <path
        fill="#3f3d56"
        d="M17.93 285.338v-5.767h-6.921v5.767h6.921zM17.353 289.952h-6.344v5.768h6.921v-5.768h-.577zM22.543 279.571h6.921v5.767h-6.921zM22.543 289.952h6.921v5.767h-6.921zM65.222 285.338v-5.767h-6.921v5.767h6.921zM64.645 289.952h-6.344v5.768h6.921v-5.768h-.577zM69.836 279.571h6.921v5.767h-6.921zM69.836 289.952h6.921v5.767h-6.921zM113.667 169.992v-5.768h-6.921v5.768H113.667zM113.091 174.606h-6.345v5.767h6.921v-5.767h-.576zM118.281 164.224h6.921v5.767h-6.921zM118.281 174.606h6.921v5.767h-6.921zM113.667 202.289v-5.767h-6.921v5.767H113.667zM113.091 206.903h-6.345v5.767h6.921v-5.767h-.576zM118.281 196.522h6.921v5.767h-6.921zM118.281 206.903h6.921v5.767h-6.921zM113.667 234.586v-5.767h-6.921v5.767H113.667zM113.091 239.2h-6.345v5.767h6.921V239.2h-.576zM118.281 228.819h6.921v5.767h-6.921zM118.281 239.2h6.921v5.767h-6.921zM113.667 266.883v-5.767h-6.921v5.767H113.667zM113.091 271.497h-6.345v5.767h6.921v-5.767h-.576zM118.281 261.116h6.921v5.767h-6.921zM118.281 271.497h6.921v5.767h-6.921zM11.009 169.992H77.91v13.842H11.009zM11.009 197.675H77.91v13.842H11.009zM11.009 225.358H77.91V239.2H11.009zM11.009 253.041H77.91v13.842H11.009z"
      />
      <path
        d="M138.205 302.355a19.8 19.8 0 00-4.148 2.867 19.742 19.742 0 00-4.217-2.867 19.8 19.8 0 00-4.148 2.867 19.742 19.742 0 00-4.216-2.867s-6.501 3.198-6.483 7.105q0 .147.013.292c.222 2.558 6.944 3.21 10.637 2.004a15.247 15.247 0 008.364 0c3.676 1.225 10.535.523 10.736-2.064q.01-.146.01-.292c-.018-3.908-6.548-7.045-6.548-7.045z"
        fill="currentColor"
      />
      <path
        fill="#3f3d56"
        d="M108.177 167.108l-5.768-4.614 32.297-28.836h81.896v25.376l-53.059 35.757-55.366-27.683z"
      />
      <path
        fill="#ccc"
        d="M231.534 149.833v-15.599h-10.873v3.82l-4.059-4.396-26.529 28.836-10.381 6.921-16.097 117.601 24.275 24.275h56.416V163.648l-12.752-13.815z"
      />
      <path fill="#f2f2f2" d="M102.409 162.494h87.663v148.797h-87.663z" />
      <path fill="#ccc" d="M136.437 274.957h16.149v36.334h-16.149z" />
      <path
        fill="#3f3d56"
        d="M119.135 285.338v-5.767h-6.921v5.767h6.921zM118.558 289.952h-6.344v5.768h6.921v-5.768h-.577zM123.748 279.571h6.921v5.767h-6.921zM123.748 289.952h6.921v5.767h-6.921zM166.427 285.338v-5.767h-6.921v5.767h6.921zM165.85 289.952h-6.344v5.768h6.921v-5.768h-.577zM171.041 279.571h6.921v5.767h-6.921zM171.041 289.952h6.921v5.767h-6.921zM214.872 169.992v-5.768h-6.921v5.768H214.872zM214.296 174.606h-6.345v5.767h6.921v-5.767h-.576zM219.486 164.224h6.921v5.767h-6.921zM219.486 174.606h6.921v5.767h-6.921zM214.872 202.289v-5.767h-6.921v5.767H214.872zM214.296 206.903h-6.345v5.767h6.921v-5.767h-.576zM219.486 196.522h6.921v5.767h-6.921zM219.486 206.903h6.921v5.767h-6.921zM214.872 234.586v-5.767h-6.921v5.767H214.872zM214.296 239.2h-6.345v5.767h6.921V239.2h-.576zM219.486 228.819h6.921v5.767h-6.921zM219.486 239.2h6.921v5.767h-6.921zM214.872 266.883v-5.767h-6.921v5.767H214.872zM214.296 271.497h-6.345v5.767h6.921v-5.767h-.576zM219.486 261.116h6.921v5.767h-6.921zM219.486 271.497h6.921v5.767h-6.921zM112.214 169.992h66.901v13.842h-66.901zM112.214 197.675h66.901v13.842h-66.901zM112.214 225.358h66.901V239.2h-66.901zM112.214 253.041h66.901v13.842h-66.901z"
      />
      <circle cx={121.748} cy={28.641} r={28.641} fill="#ff6584" />
      <path fill="#3f3d56" d="M302.512 200.449h2.793v110.319h-2.793z" />
      <path
        d="M332.56 232.555q.008 1.82-.034 3.624c-1.002 43.427-53.066 43.667-54.468.25q-.058-1.802-.067-3.622c-.224-48.543 26.879-88.02 26.879-88.02s27.466 39.225 27.69 87.768z"
        fill="#e6e6e6"
      />
      <path
        d="M295.591 302.11a19.8 19.8 0 00-4.148 2.867 19.742 19.742 0 00-4.216-2.867 19.8 19.8 0 00-4.148 2.867 19.742 19.742 0 00-4.216-2.867s-6.502 3.198-6.484 7.105q.001.147.014.292c.222 2.558 6.944 3.21 10.636 2.005a15.247 15.247 0 008.364 0c3.677 1.225 10.536.523 10.736-2.065q.012-.145.011-.292c-.018-3.907-6.549-7.045-6.549-7.045z"
        fill="#ccc"
      />
      <path
        fill="#3f3d56"
        d="M373.739 263.999l-3.46-5.767 32.297-52.775h83.049v8.074l-29.99 57.389-34.604 6.921-47.292-13.842z"
      />
      <path
        fill="#ccc"
        d="M499.921 246.794v-43.139h-10.873v5.691l-3.423-3.889-27.683 52.775-4.614 4.614-5.767 23.069 10.381 25.376h53.059v-51.906l-11.08-12.591z"
      />
      <path fill="#f2f2f2" d="M370.279 258.232h87.663v53.059h-87.663z" />
      <path fill="#3f3d56" d="M427.375 274.957h18.455v16.149h-18.455z" />
      <path fill="#ccc" d="M403.729 274.381h16.149v36.911h-16.149z" />
      <path
        fill="#3f3d56"
        d="M385.274 280.148v-5.767h-6.921v5.767h6.921zM384.697 284.762h-6.344v5.767h6.921v-5.767h-.577zM389.888 274.381h6.921v5.767h-6.921zM389.888 284.762h6.921v5.767h-6.921zM482.742 281.561v-5.767h-6.921v5.767h6.921zM482.165 286.175h-6.344v5.767h6.921v-5.767h-.577zM487.355 275.794h6.921v5.767h-6.921zM487.355 286.175h6.921v5.767h-6.921zM410.036 227.148l-.911-1.517 8.498-13.886h21.851v2.124l-7.89 15.1-9.105 1.821-12.443-3.642z"
      />
      <path
        fill="#ccc"
        d="M439.474 211.745l-7.283 13.886-1.214 1.214-1.518 6.07 2.732 6.676h13.96v-13.657l-6.677-14.189z"
      />
      <path fill="#f2f2f2" d="M409.125 225.631h23.065v13.961h-23.065z" />
      <path
        fill="#3f3d56"
        d="M418.897 231.647v-2.754h-3.304v2.754h3.304zM418.622 233.85h-3.029v2.753h3.304v-2.753h-.275zM421.1 228.893h3.304v2.754H421.1zM421.1 233.85h3.304v2.754H421.1zM478.29 263.999l-3.461-5.767 32.297-52.775h83.05v8.074l-29.99 57.389-34.604 6.921-47.292-13.842z"
      />
      <path
        fill="#ccc"
        d="M604.472 246.794v-43.139h-10.873v5.691l-3.423-3.889-27.683 52.775-4.614 4.614-5.768 23.069 10.382 25.376h53.059v-51.906l-11.08-12.591z"
      />
      <path fill="#f2f2f2" d="M474.829 258.232h87.663v53.059h-87.663z" />
      <path fill="#3f3d56" d="M531.926 274.957h18.455v16.149h-18.455z" />
      <path fill="#ccc" d="M508.28 274.38h16.149v36.911H508.28z" />
      <path
        fill="#3f3d56"
        d="M489.824 280.148v-5.768h-6.921v5.768H489.824zM489.248 284.762h-6.345v5.767h6.921v-5.767h-.576zM494.438 274.38h6.921v5.767h-6.921zM494.438 284.762h6.921v5.767h-6.921zM587.292 280.725v-5.768h-6.921v5.768h6.921zM586.715 285.338h-6.344v5.768h6.921v-5.768h-.577zM591.906 274.957h6.921v5.767h-6.921zM591.906 285.338h6.921v5.767h-6.921zM579.495 263.999l-3.461-5.767 32.297-52.775h83.05v8.074l-29.99 57.389-34.604 6.921-47.292-13.842z"
      />
      <path
        fill="#ccc"
        d="M705.677 246.794v-43.139h-10.873v5.691l-3.423-3.889-27.683 52.775-4.614 4.614-5.768 23.069 10.382 25.376h53.059v-51.906l-11.08-12.591z"
      />
      <path fill="#f2f2f2" d="M576.034 258.232h87.663v53.059h-87.663z" />
      <path fill="#3f3d56" d="M633.131 274.957h18.455v16.149h-18.455z" />
      <path fill="#ccc" d="M609.485 274.38h16.149v36.911h-16.149z" />
      <path
        fill="#3f3d56"
        d="M591.029 280.148v-5.768h-6.92v5.768h6.92zM590.453 284.762h-6.344v5.767h6.92v-5.767h-.576zM595.643 274.38h6.921v5.767h-6.921zM595.643 284.762h6.921v5.767h-6.921zM688.497 280.725v-5.768h-6.921v5.768H688.497zM687.921 285.338h-6.345v5.768h6.921v-5.768h-.576zM693.111 274.957h6.921v5.767h-6.921zM693.111 285.338h6.921v5.767h-6.921zM512.077 227.985l-.91-1.518 8.497-13.886h21.852v2.125l-7.891 15.1-9.105 1.82-12.443-3.641z"
      />
      <path
        fill="#ccc"
        d="M541.516 212.581l-7.284 13.886-1.214 1.214-1.517 6.07 2.731 6.677h13.961v-13.657l-6.677-14.19z"
      />
      <path fill="#f2f2f2" d="M511.167 226.467h23.065v13.961h-23.065z" />
      <path
        fill="#3f3d56"
        d="M520.939 232.483v-2.754h-3.305v2.754H520.939zM520.663 234.686h-3.029v2.754h3.305v-2.754h-.276zM523.142 229.729h3.304v2.754h-3.304zM523.142 234.686h3.304v2.754h-3.304zM614.119 227.148l-.911-1.517 8.498-13.886h21.851v2.124l-7.891 15.1-9.104 1.821-12.443-3.642z"
      />
      <path
        fill="#ccc"
        d="M643.557 211.745l-7.284 13.886-1.214 1.214-1.517 6.07 2.731 6.676h13.961v-13.657l-6.677-14.189z"
      />
      <path fill="#f2f2f2" d="M613.208 225.631h23.065v13.961h-23.065z" />
      <path
        fill="#3f3d56"
        d="M622.98 231.647v-2.754h-3.304v2.754h3.304zM622.705 233.85h-3.029v2.753h3.304v-2.753h-.275zM625.183 228.893h3.304v2.754h-3.304zM625.183 233.85h3.304v2.754h-3.304zM684.045 263.999l-3.46-5.767 32.297-52.775h83.05v8.074l-29.991 57.389-34.604 6.921-47.292-13.842z"
      />
      <path
        fill="#ccc"
        d="M810.228 212.859v-9.204h-10.874v5.691l-3.422-3.889-27.684 52.775-4.614 4.614-5.767 23.069 10.381 25.376h53.06v-51.906l-11.08-46.526z"
      />
      <path fill="#f2f2f2" d="M680.585 258.232h87.663v53.059h-87.663z" />
      <path fill="#3f3d56" d="M737.682 274.957h18.455v16.149h-18.455z" />
      <path fill="#ccc" d="M714.035 274.38h16.149v36.911h-16.149z" />
      <path
        fill="#3f3d56"
        d="M695.58 280.148v-5.768h-6.921v5.768h6.921zM695.003 284.762h-6.344v5.767h6.921v-5.767h-.577zM700.194 274.38h6.921v5.767h-6.921zM700.194 284.762h6.921v5.767h-6.921zM793.048 280.725v-5.768h-6.921v5.768h6.921zM792.471 285.338h-6.344v5.768h6.921v-5.768h-.577zM797.662 274.957h6.921v5.767h-6.921zM797.662 285.338h6.921v5.767h-6.921zM716.16 227.985l-.91-1.518 8.497-13.886h21.852v2.125l-7.891 15.1-9.105 1.82-12.443-3.641z"
      />
      <path
        fill="#ccc"
        d="M745.599 212.581l-7.284 13.886-1.214 1.214-1.518 6.07 2.732 6.677h13.96v-13.657l-6.676-14.19z"
      />
      <path fill="#f2f2f2" d="M715.25 226.467h23.065v13.961H715.25z" />
      <path
        fill="#3f3d56"
        d="M725.021 232.483v-2.754h-3.304v2.754h3.304zM724.746 234.686h-3.029v2.754h3.304v-2.754h-.275zM727.224 229.729h3.304v2.754h-3.304zM727.224 234.686h3.304v2.754h-3.304zM.836 310.718h919.582v1.673H.836zM0 467.126h919.582v1.673H0z"
      />
      <path fill="#3f3d56" d="M857.478 200.433h2.792v110.286h-2.792z" />
      <path
        d="M887.517 232.529q.008 1.82-.034 3.622c-1.001 43.414-53.05 43.654-54.451.251q-.059-1.802-.067-3.622c-.224-48.528 26.87-87.994 26.87-87.994s27.458 39.215 27.682 87.743z"
        fill="#e6e6e6"
      />
      <path fill="#3f3d56" d="M278.059 418.723h29.428v4.671h-29.428z" />
      <path
        d="M520.255 419.77l-6.072 1.404-230.752.124-2.075-4.835a48.798 48.798 0 01-3.588-26.386c.994-6.677 3.484-13.312 9.14-16.193l10.24-68.204 127.664-.228 49.393 39.838s23.299-.419 35.957 15.34c4.006 4.99 6.947 11.603 7.737 20.37l.5 8.198z"
        fill="currentColor"
      />
      <circle cx={469.573} cy={418.629} r={28.494} fill="#3f3d56" />
      <circle cx={469.573} cy={418.629} r={14.997} fill="#ccc" />
      <circle cx={328.973} cy={418.704} r={28.494} fill="#3f3d56" />
      <circle cx={328.973} cy={418.704} r={14.997} fill="#ccc" />
      <path
        fill="#fff"
        d="M454.581 340.633l-68.928.03h-8.414l-14.207.01v-1.036l-.01-12.492-.01-14.027h9.451l8.414-.01 14.905-.01h8.414l17.207-.01 33.178 27.545zM351.817 340.683l-36.428.02-.01-7.148v-12.491l-.01-7.916h5.334l8.414-.01 22.69-.01.01 27.555z"
      />
      <path
        fill="#3f3d56"
        d="M363.043 361.23h4.671v8.875h-4.671zM444.779 348.576l.002 4.67-8.875.006-.002-4.671z"
      />
      <path
        d="M439.17 331.106h.513a9.763 9.763 0 019.763 9.762 9.763 9.763 0 01-9.763 9.763h-.514v-19.525zM518.398 389.198a15.09 15.09 0 01-8.236-28.569c4.006 4.992 6.947 11.604 7.737 20.372z"
        fill="#3f3d56"
      />
      <path
        fill="#f2f2f2"
        d="M380.877 313.108l-17.845 26.529-.01-12.492 9.441-14.027 8.414-.01zM329.117 313.138l-13.738 20.417v-12.491l5.324-7.916 8.414-.01zM404.196 313.098l-18.543 27.565h-8.414l18.543-27.565h8.414z"
      />
      <path
        fill="#3f3d56"
        d="M699.712 360.028l-17.876-.01.001-2.837 17.876.01z"
      />
      <path
        d="M552.592 357.822l3.689.853 140.168.075 1.26-2.937a29.642 29.642 0 002.18-16.028c-.604-4.056-2.117-8.086-5.553-9.836l-6.22-41.43-77.548-.138-30.003 24.199s-14.153-.255-21.842 9.318a22.468 22.468 0 00-4.7 12.374l-.303 4.98z"
        fill="#3f3d56"
      />
      <circle cx={583.379} cy={357.129} r={17.308} fill="#3f3d56" />
      <circle cx={583.379} cy={357.129} r={9.11} fill="#ccc" />
      <circle cx={668.785} cy={357.175} r={17.308} fill="#3f3d56" />
      <circle cx={668.785} cy={357.175} r={9.11} fill="#ccc" />
      <path
        fill="#fff"
        d="M592.486 309.751l41.869.019h5.111l8.63.006v-.63l.006-7.588.006-8.521h-5.741l-5.111-.006-9.053-.006h-5.112l-10.452-.006-20.153 16.732zM654.908 309.782l22.128.012.006-4.342v-7.588l.006-4.808h-3.24l-5.111-.006-13.782-.006-.007 16.738z"
      />
      <path
        fill="#3f3d56"
        d="M648.087 327.654l-2.837-.001.003-5.391 2.837.001zM603.83 314.579l-.001 2.837-5.391-.003.001-2.837z"
      />
      <path
        d="M601.844 315.826h-.312a5.93 5.93 0 01-5.927-5.934 5.93 5.93 0 015.933-5.927h.312l-.006 11.86zM553.72 339.251a9.166 9.166 0 005.003-17.353 22.468 22.468 0 00-4.7 12.374z"
        fill="#3f3d56"
      />
      <path
        fill="#f2f2f2"
        d="M637.256 293.031l10.84 16.115.006-7.588-5.735-8.521-5.111-.006zM668.697 293.05l8.345 12.402v-7.588l-3.234-4.808-5.111-.006zM623.091 293.025l11.264 16.745h5.111l-11.263-16.745h-5.112z"
      />
      <path
        d="M160.14 486.959s0 31.718 7.28 40.038c0 0 1.56 4.16 2.08 5.72a21.86 21.86 0 001.04 2.6v2.079s14.04-1.56 15.6-5.2l-2.6-3.12s-.52-.52 0-2.08a1.068 1.068 0 00-1.04-1.56l-3.64-8.319.52-34.318-2.6-47.318-22.359-1.04z"
        fill="#2f2e41"
      />
      <path
        d="M171.58 534.276s-3.64 10.92 0 11.44 35.359 1.04 34.839-3.12-10.92-3.64-10.92-3.64l-10.92-6.76zM139.342 435.481a23.594 23.594 0 003.12 14.04c4.16 7.28 1.56 31.718 1.56 31.718l-36.918 32.238s7.28 12.48 9.88 11.96 43.677-33.799 43.677-33.799l16.119-54.077z"
        fill="#2f2e41"
      />
      <path
        d="M107.61 512.1s-11.17 2.77-9.661 6.124 18.05 30.42 21.285 27.755-2.77-11.172-2.77-11.172l-.137-12.841z"
        fill="#2f2e41"
      />
      <circle cx={159.621} cy={338.766} r={11.959} fill="#ffb8b8" />
      <path
        d="M150.211 342.986l.529 15.39 10.063 3.975s.987-15.758 2.38-16.631-12.972-2.734-12.972-2.734z"
        fill="#ffb8b8"
      />
      <path
        d="M163.26 364.245s-14.039-14.04-17.678-13.52-3.64 2.08-3.64 3.12 1.04 1.56 0 2.08-2.08 0-2.08 1.56-9.36 17.16-6.24 34.318 6.76 25.48 5.2 34.839-.52 11.439-.52 11.439 38.998 3.12 39.518-.52-1.56-1.56 1.04-4.16 1.56-2.6 1.56-4.16-11.44-64.996-17.16-64.996z"
        fill="#575a89"
      />
      <path
        d="M155.981 434.961s6.24 15.08 10.92 11.44-2.08-16.12-2.08-16.12z"
        fill="#ffb8b8"
      />
      <path
        d="M140.902 365.285s-12.217 1.398-7.668 23.838 22.227 48.438 22.227 48.438l11.96-5.72-15.6-30.678 3.64-19.24s2.08-18.198-14.56-16.638z"
        fill="#575a89"
      />
      <path
        opacity={0.2}
        d="M151.561 401.423l17.159 28.598-1.559 1.56-15.6-30.158zM142.479 414.75l13.762 22.551h-4.68l-9.082-22.551z"
      />
      <path
        d="M154.208 345.952a17.215 17.215 0 013.14-.935 8.217 8.217 0 005.46-9.212 4.7 4.7 0 01-.197-1.518 2.9 2.9 0 012.417-2.13 23.792 23.792 0 003.365-.64 5.098 5.098 0 002.975-4.088 8.444 8.444 0 00-1.128-5.09l-.403 1.159a4.297 4.297 0 01-1.315-1.968 2.71 2.71 0 00-2.065 1.661c-.646.381-.74-1.184-1.453-1.415a1.282 1.282 0 00-.891.22c-1.438.67-3.11.097-4.652-.275a17.513 17.513 0 00-8.13-.01 9.731 9.731 0 00-4.805 2.473 11.529 11.529 0 00-2.248 3.862 22.25 22.25 0 00-1.813 10.806 15.295 15.295 0 003.604 8.104c1.03 1.186 4.387 5.322 6.228 4.617 2.314-.886-.815-4.18 1.91-5.62z"
        fill="#2f2e41"
      />
      <path
        opacity={0.2}
        d="M159.883 491.608l13.684-35.877.691.264-13.683 35.876z"
      />
      <circle cx={163.187} cy={366.36} r={0.74} fill="#d0cde1" />
      <path
        fill="#d0cde1"
        d="M163.187 366.36l6.287 20.342M169.474 387.072a.37.37 0 01-.353-.261l-6.287-20.342a.37.37 0 11.706-.218l6.288 20.342a.37.37 0 01-.354.479z"
      />
      <circle cx={833.834} cy={345.693} r={12.489} fill="#2f2e41" />
      <path
        d="M816.082 421.346l-1.893 3.787s-6.06 9.846-1.894 10.982 5.491-7.385 5.491-7.385l.758-4.544z"
        fill="#a0616a"
      />
      <path
        fill="#d0cde1"
        d="M823.656 402.033l-4.734 12.496-4.733 8.71 5.87 3.787 4.733-8.331 5.681-13.065-6.817-3.597z"
      />
      <path
        d="M837.1 460.54l9.467 10.036 16.663 28.213 7.195-2.272-8.52-16.852s-4.924-12.876-7.385-14.58-6.628-12.876-6.628-12.876l-4.544-3.597zM817.597 466.032l-.757 3.219s-2.462 10.035-6.249 14.58l-9.088 15.715-6.817-2.272 13.444-31.81z"
        fill="#a0616a"
      />
      <circle cx={831.703} cy={350.057} r={10.225} fill="#a0616a" />
      <path
        d="M839.75 355.075l1.326 10.982-8.52 4.165s0-9.467-2.273-11.929zM866.448 425.89l.947 3.22s6.249 12.307.947 12.307-6.249-11.361-6.249-11.361l-.568-2.84z"
        fill="#a0616a"
      />
      <path
        d="M822.899 413.015l1.325 9.278-16.094 33.893-.947 9.846 30.106 3.787 6.627-18.367 10.604 13.633-6.06-14.012s-1.893-9.467-1.325-11.928-.379-14.77-2.083-17.799-22.153-8.331-22.153-8.331zM862.093 498.789l9.09-3.03 2.84 4.544s5.49 1.515 5.301 5.491a67.66 67.66 0 00.947 10.793l-3.977.379-1.514-7.763-7.764 9.278s-13.822.757-14.39-1.515 9.846-4.734 9.846-4.734l1.704-8.142zM794.118 496.138l8.331 2.65v1.894s2.462 3.787 2.083 7.006-2.083 10.982-2.083 10.982h-4.355l.19-7.195-8.71 7.195s-15.527-1.136-15.527-3.598 11.93-4.165 11.93-4.165z"
        fill="#2f2e41"
      />
      <path
        d="M831.987 367.95s7.764-7.763 11.361-5.87v3.409s5.302 2.461 5.491 6.248 5.68 38.248 5.68 38.248l12.876 44.875s-3.976 6.249-18.556-.757l-9.089-30.864s9.657 34.84 4.923 34.272-23.29-43.739-23.29-43.739l1.326-20.45s-3.03-8.899 3.03-14.958z"
        fill="#d0cde1"
      />
      <path
        d="M845.242 369.086s3.219 1.136 5.49 6.06 13.634 39.573 13.634 39.573l3.03 12.307-8.521 2.083-4.166-12.686-15.526-28.78s-2.462-15.149 6.059-18.557z"
        fill="#d0cde1"
      />
      <path
        d="M844.493 341.9a7.177 7.177 0 00-3.38-5.836c1.04-2.087 1.968-4.47 1.283-6.698a5.112 5.112 0 00-3.85-3.446 10.033 10.033 0 00-2.993.039l-4.665.529a10.19 10.19 0 00-4.373 1.178 5.066 5.066 0 00-.585 8.13c-3.265 2.61-5.446 4.593-6.931 8.5a14.035 14.035 0 018.816-3.156 8.403 8.403 0 018.828 7.7 15.55 15.55 0 00.287 3.26 2.398 2.398 0 002.357 1.875c-.15.02-1.075-2.756-.424-4.038l.01-.021a1.22 1.22 0 01.663-.569 1.91 1.91 0 012.539 1.328c.362 1.39.941 3.166 1.448 2.695.663-.617.384-6.058.563-6.901a15.835 15.835 0 00.407-4.569z"
        fill="#2f2e41"
      />
      <path d="M841.062 336.027s-10.262.669-15.17-.223" fill="#d0cde1" />
      <path
        d="M840.48 334.654c1.04-2.088 1.968-4.47 1.283-6.699a5.06 5.06 0 00-1.79-2.516 5.124 5.124 0 012.737 3.084c.685 2.23-.244 4.611-1.283 6.699-.824-.124 1.123.535-.947-.568z"
        fill="#2f2e41"
      />
      <path
        opacity={0.2}
        d="M837.194 387.737l14.769 26.13 5.681 14.201-7.953-13.633-12.497-26.698z"
      />
      <path
        d="M139.028 536.251s-4.63 10.078-8.389 12.904c-3.806-2.834-8.526-12.904-8.526-12.904s-4.63 10.078-8.39 12.904c-3.805-2.834-8.526-12.904-8.526-12.904s-13.149 13.442-13.113 19.808a4.668 4.668 0 00.027.475c.45 4.168 14.044 5.23 21.512 3.266a38.02 38.02 0 0016.915 0c7.437 1.996 21.308.852 21.713-3.363a4.67 4.67 0 00.022-.476c-.037-6.366-13.245-19.71-13.245-19.71z"
        fill="currentColor"
      />
      <path
        d="M415.268 536.251s-4.63 10.078-8.389 12.904c-3.806-2.834-8.527-12.904-8.527-12.904s-4.63 10.078-8.389 12.904c-3.806-2.834-8.526-12.904-8.526-12.904s-13.15 13.442-13.113 19.808a4.668 4.668 0 00.027.475c.449 4.168 14.043 5.23 21.511 3.266a38.02 38.02 0 0016.916 0c7.436 1.996 21.307.852 21.713-3.363a4.67 4.67 0 00.021-.476c-.036-6.366-13.244-19.71-13.244-19.71z"
        fill="#e6e6e6"
      />
      <path
        d="M689.72 536.251s-4.63 10.078-8.39 12.904c-3.806-2.834-8.526-12.904-8.526-12.904s-4.63 10.078-8.389 12.904c-3.806-2.834-8.527-12.904-8.527-12.904s-13.149 13.442-13.112 19.808a4.67 4.67 0 00.027.475c.448 4.168 14.043 5.23 21.511 3.266a38.02 38.02 0 0016.916 0c7.436 1.996 21.307.852 21.712-3.363a4.67 4.67 0 00.022-.476c-.036-6.366-13.244-19.71-13.244-19.71z"
        fill="currentColor"
      />
      <path
        d="M155.614 47.29l-.12.067a8.96 8.96 0 01-8.544.03l-.226-.121a9.003 9.003 0 00-8.534.03l-.113.06a8.96 8.96 0 01-8.544.03l-.234-.125a8.952 8.952 0 00-8.45-.015c-3.975 2.14-9.347 5.8-9.323 9.932a4.806 4.806 0 00.028.489c.462 4.291 14.459 5.385 22.148 3.362a39.145 39.145 0 0017.416 0c7.657 2.055 21.938.878 22.356-3.463a4.81 4.81 0 00.022-.49c-.024-4.134-5.443-7.754-9.442-9.864a8.943 8.943 0 00-8.44.079zM415.737 92.646l-.12.066a8.96 8.96 0 01-8.544.03l-.226-.12a9.003 9.003 0 00-8.534.029l-.113.061a8.96 8.96 0 01-8.544.03l-.234-.125a8.952 8.952 0 00-8.45-.015c-3.974 2.14-9.347 5.799-9.323 9.931a4.806 4.806 0 00.028.49c.462 4.29 14.459 5.384 22.148 3.362a39.145 39.145 0 0017.416 0c7.657 2.054 21.938.877 22.356-3.463a4.81 4.81 0 00.022-.49c-.024-4.134-5.443-7.755-9.442-9.865a8.943 8.943 0 00-8.44.08zM595.522 49.258l-.121.066a8.96 8.96 0 01-8.544.03l-.226-.12a9.003 9.003 0 00-8.534.029l-.113.061a8.96 8.96 0 01-8.543.03l-.235-.125a8.952 8.952 0 00-8.45-.015c-3.974 2.14-9.346 5.799-9.323 9.931a4.808 4.808 0 00.028.49c.462 4.29 14.459 5.384 22.148 3.362a39.145 39.145 0 0017.417 0c7.656 2.054 21.938.877 22.355-3.463a4.807 4.807 0 00.022-.49c-.023-4.134-5.443-7.755-9.442-9.865a8.943 8.943 0 00-8.44.08z"
        fill="#e6e6e6"
      />
      <path fill="#3f3d56" d="M0 559.131h919.582v1.673H0z" />
    </svg>
  );
}

export default SvgTransito;
